//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Diff2HtmlUI } from 'diff2html/lib/ui/js/diff2html-ui-slim.js';
import 'diff2html/bundles/css/diff2html.min.css';
import { createTwoFilesPatch } from 'diff';

export default {
  props: {
    // diff数据，一个带from和to的对象数组
    diffData: {
      type: Array,
      default: () => [],
    },
    // 已经被diff后的字符串
    diffStr: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      diffType: 'side-by-side',
    };
  },
  watch: {
    diffData() {
      this.init();
    },
    diffStr() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.diffType = 'side-by-side';
      this.renderArrayDiff();
    },
    changeDiffType() {
      this.renderArrayDiff();
    },
    renderArrayDiff() {
      if ((!this.diffData && !this.diffStr) || !this.$refs.diffContainer) {
        return;
      }
      try {
        let diffString = ';';
        if (this.diffStr) {
          diffString = this.diffStr;
        } else {
          // 解析数组数据
          const arrayData = this.diffData;

          if (!Array.isArray(arrayData) || arrayData.length === 0) {
            this.$refs.diffContainer.innerHTML =
              '<div style="padding: 20px; text-align: center; color: #999;">暂无差异数据</div>';
            return;
          }

          // 使用jsdiff生成标准的统一diff格式
          arrayData.forEach((item) => {
            if (item && typeof item === 'object' && 'from' in item && 'to' in item) {
              // 尝试格式化JSON，如果失败则使用原值
              const formatJson = (content) => {
                if (typeof content === 'string') {
                  try {
                    // 尝试解析JSON并重新格式化
                    const parsed = JSON.parse(content);
                    return JSON.stringify(parsed, null, 2);
                  } catch (error) {
                    // 解析失败，返回原值
                    return content;
                  }
                } else {
                  // 非字符串类型，直接格式化
                  if (content === null || content === undefined) return '';
                  return JSON.stringify(content, null, 2);
                }
              };
              const fromContent = formatJson(item.from);
              const toContent = formatJson(item.to);
              if (fromContent === toContent) return;
              // 处理path字段，如果是数组则join成文件名
              const { fileName } = item;
              const oldFileName = item.oldFileName || fileName || '';
              const newFileName = item.newFileName || fileName || '';
              const oldHeader = item.oldHeader || '';
              const newHeader = item.newHeader || '';
              // 使用diff库的createTwoFilesPatch生成标准统一diff格式
              // 使用相同的文件名，只展示内容变化，不展示重命名
              // 添加context参数来显示完整文件内容
              const patch = createTwoFilesPatch(
                oldFileName, // 原始文件名
                newFileName, // 新文件名（相同）
                fromContent, // 原始内容
                toContent, // 新内容
                oldHeader, // 原始文件标题
                newHeader, // 新文件标题
                // {
                //   context: 15, // 增加上下文行数，显示完整文件内容
                //   ignoreWhitespace: false, // 不忽略空白字符
                // },
              );
              diffString += patch;
              diffString += '\n';
            }
          });
        }
        if (!diffString.trim()) {
          this.$refs.diffContainer.innerHTML =
            '<div style="padding: 20px; text-align: center; color: #999;">暂无有效的差异数据</div>';
          return;
        }

        // 配置 diff2html 选项 - 显示完整文件内容
        const options = {
          drawFileList: false,
          matching: 'lines',
          outputFormat: this.diffType,
          fileListToggle: false,
          fileListStartVisible: false,
          fileContentToggle: true, // 允许切换文件内容显示
          highlight: true,
          renderNothingWhenEmpty: false, // 即使没有差异也渲染内容
        };

        // 渲染 diff
        const ui = new Diff2HtmlUI(this.$refs.diffContainer, diffString, options);
        ui.draw();
        ui.highlightCode();
      } catch (error) {
        console.error('渲染数组差异时出错:', error);
        this.$refs.diffContainer.innerHTML =
          '<div style="padding: 20px; text-align: center; color: #f56c6c;">渲染差异数据时出错</div>';
      }
    },
  },
};
